var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"home-container"},[_c('h3',{staticClass:"text-center"},[_vm._v("ИМЖ ЦАХИМ БОДЛОГЫН САН")]),_c('carousel',{staticClass:"carousel row my-5",attrs:{"per-page":4,"perPageCustom":[
        [300, 1],
        [900, 2],
        [1300, 3],
        [1599, 4],
      ],"mouse-drag":true,"autoplay":true,"paginationColor":"#ffffff","paginationSize":15}},_vm._l((_vm.homePage),function(home,index){return _c('slide',{key:index.home},[_c('div',{staticClass:"slide"},[_c('div',{staticClass:"image-carousel-content"},[_c('div',{class:{
                image1: index === 0,
                image2: index === 1,
                image3: index === 2,
                image4: index === 3,
                image5: index === 4,
              }},[_c('div',{staticClass:"image-carousel"})])]),_c('div',{staticClass:"carousel-text"},[_c('span',{staticClass:"carousel-text-in"},[_vm._v(" "+_vm._s(home.text)+" ")])])])])}),1)],1),(!_vm.loggedIn)?_c('span',{staticClass:"register-link"},[_vm._v(" ИЛҮҮ ИХ БОЛОМЖИЙГ АВАХЫГ ХҮСВЭЛ "),_c('b-link',{attrs:{"to":"Registration"}},[_vm._v("ЭНД")]),_vm._v("ДАРЖ БҮРТГҮҮЛЭЭРЭЙ ")],1):_vm._e(),_c('ClassifyCom')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }